import { FarmEditor } from "@agricircle/shared/farms/components";


export default () => {
    return (<FarmEditor />);
};
